export default __webpack_public_path__ + "static/media/b50237957c295c1425b0e732df7c2987.svg";